export default __webpack_public_path__ + "static/media/ai_menu.985c0e12.svg";